export default __webpack_public_path__ + "static/emptyCart-009ffb1fc26206b72359943f2bb193e0.png";